export const tenantTableHeaders = [
  {
    Header: "S.No",
  },
  {
    Header: "Name",
  },
  {
    Header: "NameSpace",
  },
  {
    Header: "Mobile Number",
  },
  {
    Header: "Email",
  },
  {
    Header: "Type",
  },
  {
    Header: "GST Paid",
  },
  {
    Header: "Payouts Enabled",
  },
  {
    Header: "Actions",
  },
];
